import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-gutter-y-lg" }
const _hoisted_2 = { class: "row text-subtitle1" }
const _hoisted_3 = { class: "col-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("strong", null, "Client: ", -1)
const _hoisted_5 = { class: "col-6 text-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("strong", null, "Keywords: ", -1)
const _hoisted_7 = { class: "col-3 text-right" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("strong", null, "Total Matches:", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_post = _resolveComponent("post")!
  const _component_posts_grid = _resolveComponent("posts-grid")!
  const _component_posts = _resolveComponent("posts")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createTextVNode(" " + _toDisplayString(_ctx.$filters.clientName(_ctx.postSearch.client)), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createTextVNode(" " + _toDisplayString(_ctx.postSearch.keywords.join(', ')), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createTextVNode(" " + _toDisplayString(_ctx.postSearch.numPostsMatched), 1)
      ])
    ]),
    _createVNode(_component_posts, {
      fetch: _ctx.loadPosts,
      filters: _ctx.filters,
      "infinite-scroll": "",
      "scroll-target": ".custom-scrollbar",
      persist: ""
    }, {
      default: _withCtx(({ visiblePosts }) => [
        _createVNode(_component_posts_grid, { posts: visiblePosts }, {
          default: _withCtx((post) => [
            _createVNode(_component_post, {
              post: post,
              highlight: _ctx.getHighlightRules(post),
              "show-client": "",
              notes: "",
              trash: "",
              actions: "",
              scrollable: ""
            }, null, 8, ["post", "highlight"])
          ]),
          _: 2
        }, 1032, ["posts"])
      ]),
      _: 1
    }, 8, ["fetch", "filters"])
  ]))
}